/**
 * @fileoverview 404 Not Found page.
 * @description Rendered for any unmatched route (the router's wildcard "*" route). Composes the
 * auth page shell with the shared error-state card.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useTranslation } from 'react-i18next'

import notFoundIcon from '@/assets/svg/errors/icon-not-found.svg'
import AuthLayout from '@/shared/components/layouts/AuthLayout'
import ErrorStateCard from '@/shared/components/molecules/ErrorStateCard'

/**
 * @component
 */
function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <ErrorStateCard
        statusCode="404"
        icon={notFoundIcon}
        accent="primary"
        title={t('errors.notFound.title')}
        description={t('errors.notFound.description')}
      />
    </AuthLayout>
  )
}

export default NotFoundPage
